module.exports = __webpack_public_path__ + "static/media/instructivosc5.04ba7e37.png";